module.exports = __webpack_public_path__ + "img/logo-xbox.304b4bc4.svg";